import * as angular from 'angular';

/**
 * @ngdoc directive
 * @name gmailCompose
 * @restrict E
 *
 * @description Creates a gmail-compatible hyperlink to compose a new message
 *
 * @param {string} to The primary recipient(s)
 * @param {string} cc Carbon-copy recipients
 * @param {string} bcc Blind-carbon-copy recipients
 * @param {string} subject Message subject
 * @param {string} body Message body
 * @param {string} caption Override button caption
 * @param {boolean} popout Override popout (default true)
 */
let gmailComposeDirective = function() {
    return {
        template: '<a ng-if="to" href="https://mail.google.com/mail/?view=cm&fs=1&to={{to}}&su={{subject}}&body={{body}}&cc={{cc}}&bcc={{bcc}}" popout="popout==undefined || popout" class="btn btn-default btn-xs"><i class="fad fa-paper-plane"></i> {{caption||to}}</a>',
        restrict: 'E',
        scope: {
            to: '<',
            cc: '<',
            bcc: '<',
            subject: '<',
            body: '<',
            caption: '<',
            popout: '<'
        },
    };
}
export default angular.module('directives.gmailCompose', [])
    .directive('gmailCompose', gmailComposeDirective)
    .name;
